import { render, staticRenderFns } from "./ProcessInvestigator.vue?vue&type=template&id=4be14d9d&scoped=true"
import script from "./ProcessInvestigator.vue?vue&type=script&lang=js"
export * from "./ProcessInvestigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be14d9d",
  null
  
)

export default component.exports